import React from "react";
import "./src/assets/css/global.css";
import { AppProviders } from "./src/components/app-providers";

export const wrapRootElement = ({ element }) => (
    <AppProviders>{element}</AppProviders>
);

/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it
